<div class="machining-gallery">
  <div class="container-fluid pt-4">
    <a class="back-btn" routerLink="/machining">← Machine Shop</a>
    <h1 class="page-title">My Gallery</h1>

    <div class="filter-row">
      <button class="filter-chip" [class.active]="filter === 'all'"   (click)="setFilter('all')">All</button>
      <button class="filter-chip" [class.active]="filter === 'lathe'" (click)="setFilter('lathe')">Lathe</button>
      <button class="filter-chip" [class.active]="filter === 'mill'"  (click)="setFilter('mill')">Mill</button>
    </div>

    <div *ngIf="loading" class="empty-state">Loading…</div>
    <div *ngIf="!loading && filteredPhotos.length === 0" class="empty-state">
      No photos yet. Add a session in your journal to start your gallery.
    </div>

    <div class="photo-grid">
      <button
        *ngFor="let photo of filteredPhotos"
        class="photo-tile"
        (click)="openLightbox(photo)">
        <img [src]="photo.downloadUrl" [alt]="photo.caption || ''" loading="lazy">
        <div class="photo-meta">
          <span class="photo-date">{{ formatDate(photo.journalDate) }}</span>
          <span *ngIf="photo.caption" class="photo-caption">{{ photo.caption }}</span>
        </div>
      </button>
    </div>

    <div *ngIf="lightboxPhoto" class="lightbox-backdrop" (click)="closeLightbox()">
      <div class="lightbox" (click)="$event.stopPropagation()">
        <button class="lightbox-close" (click)="closeLightbox()">✕</button>
        <button class="lightbox-nav prev" [disabled]="lightboxIndex === 0" (click)="prevPhoto()">‹</button>
        <button class="lightbox-nav next" [disabled]="lightboxIndex === filteredPhotos.length - 1" (click)="nextPhoto()">›</button>
        <img [src]="lightboxPhoto.downloadUrl" [alt]="lightboxPhoto.caption || ''">
        <div class="lightbox-meta">
          <div class="lightbox-date">{{ formatDate(lightboxPhoto.journalDate) }}</div>
          <div *ngIf="lightboxPhoto.caption" class="lightbox-caption">{{ lightboxPhoto.caption }}</div>
          <button class="lightbox-delete" (click)="deletePhoto(lightboxPhoto)">Delete photo</button>
        </div>
      </div>
    </div>
  </div>
</div>
